// import React, { useState } from "react";
// import { FaSearch, FaCheckCircle, FaInfoCircle } from "react-icons/fa";
// import Navbar from "../../navbar/Navbar";
// import LinkToRegistration from "../../property/component/LinkToRegistration";
// import Stepper from "../../Stepper/component/Stepper";
// import { upsertPdeStatus } from "../ReviewApprovalSlice";
// import { toast } from "react-toastify";
// import { selectPDEInfo, selectPDEReviewStatus } from "../../user/userSlice";
// import { selectLoggedInUser } from "../../auth/authSlice";
// import { useDispatch, useSelector } from "react-redux";

// const ReviewApproval = () => {
//   const [isSubmitted, setIsSubmitted] = useState(false);
//   const { pdE_ID } = useSelector((state) => state.property);
//   const pdeInfo = useSelector(selectPDEInfo);
//   const pdeData = pdeInfo?.pdeData[0];
//   const user = useSelector(selectLoggedInUser);
//   const dispatch = useDispatch();
//   const { pdeId, dcode, srocode, statusCode, remark, updatedBy } = useState("");
//   const pdeReviewStatus = useSelector(selectPDEReviewStatus);

//   const matching = pdeReviewStatus.find((s) => s.pdE_ID === pdE_ID);
//   const statusName = matching?.statusName?.toLowerCase() || "";

//   const handleSubmit = async () => {
//     // if (!pdeId || !dcode || !srocode) {
//     //   toast.error("Missing PDE information. Cannot submit.");
//     //   return;
//     // }

//     try {
//       await dispatch(
//         upsertPdeStatus({
//           pdeId: pdE_ID,
//           dcode: pdeData.dcode,
//           srocode: pdeData.srocode,
//           statusCode: 1, // 1 = Pending
//           remark: null,
//           updatedBy: user.email,
//         })
//       ).unwrap();

//       // dispatch(fetchPDEInfoAsync(pdeId));
//       setIsSubmitted(true);
//       toast.success("PDE submitted for review.");
//     } catch (err) {
//       toast.error("Failed to submit PDE: " + err);
//     }
//   };

//   return (
//     <>
//       <Navbar />
//       <LinkToRegistration />

//       {/* <div className="flex flex-grow min-h-screen"> */}
//       <div className="flex flex-grow">
//         <div className="w-1/5 bg-white flex justify-center">
//           <Stepper />
//         </div>

//         <div className="w-0.5 bg-neutral-400"></div>

//         <div className="w-4/5 p-8">
//           <h2 className="text-2xl font-semibold mb-6">
//             Submit for Review &amp; Approval
//           </h2>

//           <div className="flex justify-center">
//             {/* {!isSubmitted ? (
//               <div className="bg-white rounded-lg shadow-sm p-6 max-w-lg w-full">
//                 <p className="text-gray-800 mb-4">
//                   Are you sure you want to submit this form for office review
//                   and approval? Once submitted, you won’t be able to make
//                   further changes.
//                 </p>
//                 <a
//                   href="/Property"
//                   className="text-blue-600 hover:underline flex items-center mb-6"
//                 >
//                   I want to recheck <FaSearch className="ml-1" />
//                 </a>
//                 <button
//                   onClick={handleSubmit}
//                   className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-6 rounded-full"
//                 >
//                   Submit PDE to Sub-Registrar office
//                 </button>
//               </div>
//             ) : (
//               <div className="bg-white rounded-lg shadow-sm p-6 max-w-lg w-full">
//                 <div className="flex flex-col items-center">
//                   <FaCheckCircle className="text-green-600 text-6xl mb-4" />
//                   <span className="text-green-600 text-lg font-medium mb-6">
//                     Successfully Submitted
//                   </span>
//                   <div className="flex items-start bg-yellow-100 border border-yellow-400 text-yellow-900 px-4 py-3 rounded-md">
//                     <FaInfoCircle className="mt-1 mr-2" />
//                     <p className="text-sm text-left">
//                       Once your PDE is reviewed &amp; approved by Sub-Registrar
//                       Office you will be eligible for submitting the stamp duty.
//                       You can see application status in dashboard.
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             )} */}
//             {/* ── If already pending, show the pending info block ───────────── */}
//             {statusName === "pending" ? (
//               <div className="bg-white rounded-lg shadow-sm p-6 max-w-lg w-full">
//                 <div className="flex flex-col items-center">
//                   <FaCheckCircle className="text-green-600 text-6xl mb-4" />
//                   <span className="text-green-600 text-lg font-medium mb-6">
//                     Successfully Submitted
//                   </span>
//                   <div className="flex items-start bg-yellow-100 border border-yellow-400 text-yellow-900 px-4 py-3 rounded-md">
//                     <FaInfoCircle className="mt-1 mr-2" />
//                     <p className="text-sm text-left">
//                       Once your PDE is reviewed &amp; approved by Sub-Registrar
//                       Office you will be eligible for submitting the stamp duty.
//                       You can see application status in dashboard.
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             ) : !isSubmitted ? (
//               /* ── Otherwise, show the "Are you sure?" form ──────────────── */
//               <div className="bg-white rounded-lg shadow-sm p-6 max-w-lg w-full">
//                 <p className="text-gray-800 mb-4">
//                   Are you sure you want to submit this form for office review
//                   and approval? Once submitted, you won’t be able to make
//                   further changes.
//                 </p>
//                 <a
//                   href="/Property"
//                   className="text-blue-600 hover:underline flex items-center mb-6"
//                 >
//                   I want to recheck <FaSearch className="ml-1" />
//                 </a>
//                 <button
//                   onClick={handleSubmit}
//                   className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-6 rounded-full"
//                 >
//                   Submit PDE to Sub-Registrar office
//                 </button>
//               </div>
//             ) : (
//               /* ── Or show the post-submit success block ─────────────────— */
//               <div className="bg-white rounded-lg shadow-sm p-6 max-w-lg w-full">
//                 <div className="flex flex-col items-center">
//                   <FaCheckCircle className="text-green-600 text-6xl mb-4" />
//                   <span className="text-green-600 text-lg font-medium mb-6">
//                     Successfully Submitted
//                   </span>
//                   <div className="flex items-start bg-yellow-100 border border-yellow-400 text-yellow-900 px-4 py-3 rounded-md">
//                     <FaInfoCircle className="mt-1 mr-2" />
//                     <p className="text-sm text-left">
//                       Once your PDE is reviewed &amp; approved by Sub-Registrar
//                       Office you will be eligible for submitting the stamp duty.
//                       You can see application status in dashboard.
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default ReviewApproval;

import React, { useState, useEffect } from "react";
import { FaSearch, FaCheckCircle, FaInfoCircle } from "react-icons/fa";
import Navbar from "../../navbar/Navbar";
import LinkToRegistration from "../../property/component/LinkToRegistration";
import Stepper from "../../Stepper/component/Stepper";
import { upsertPdeStatus } from "../ReviewApprovalSlice";
import { toast } from "react-toastify";
import { selectPDEInfo, selectPDEReviewStatus } from "../../user/userSlice";
import { selectLoggedInUser } from "../../auth/authSlice";
import { useDispatch, useSelector } from "react-redux";
import API_BASE_URL from "../../BaseURL/baseURL";

const ReviewApproval = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { pdE_ID } = useSelector((state) => state.property);
  const pdeInfo = useSelector(selectPDEInfo);
  const pdeData = pdeInfo?.pdeData[0];
  const user = useSelector(selectLoggedInUser);
  const dispatch = useDispatch();
  const { pdeId, dcode, srocode, statusCode, remark, updatedBy } = useState("");
  const pdeReviewStatus = useSelector(selectPDEReviewStatus);

  const matching = pdeReviewStatus.find((s) => s.pdE_ID === pdE_ID);
  const statusName = matching?.statusName?.toLowerCase() || "";
  const [officeList, setOfficeList] = useState([]);
  const [selectedOffice, setSelectedOffice] = useState("");
  const handleSubmit = async () => {
    // if (!pdeId || !dcode || !srocode) {
    //   toast.error("Missing PDE information. Cannot submit.");
    //   return;
    // }

    try {
      await dispatch(
        upsertPdeStatus({
          pdeId: pdE_ID,
          dcode: pdeData.dcode,
          srocode: selectedOffice,
          statusCode: 1, // 1 = Pending
          remark: null,
          updatedBy: user.email,
        })
      ).unwrap();

      // dispatch(fetchPDEInfoAsync(pdeId));
      setIsSubmitted(true);
      toast.success("PDE submitted for review.");
    } catch (err) {
      toast.error("Failed to submit PDE: " + err);
    }
  };

  useEffect(() => {
    const fetchOffices = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/PDEStatus/GetSroOfficeList?dcode=${pdeData.dcode}&srocode=${pdeData.srocode}`
        );

        if (!response.ok) {
          throw new Error("Failed to fetch office list");
        }

        const data = await response.json();
        setOfficeList(data); // ✅ data is already an array of { sroCode, sroNameEng }
      } catch (error) {
        console.error("Error fetching office list:", error);
      }
    };

    fetchOffices();
  }, []);

  const handleOfficeChange = (e) => {
    debugger;
    const selectedCode = e.target.value;
    setSelectedOffice(selectedCode);
    console.log("Selected SRO Code:", selectedCode);
  };
  return (
    <>
      <Navbar />
      <LinkToRegistration />

      {/* <div className="flex flex-grow min-h-screen"> */}
      <div className="flex flex-grow">
        <div className="w-1/5 bg-white flex justify-center">
          <Stepper />
        </div>

        <div className="w-0.5 bg-neutral-400"></div>

        <div className="w-4/5 p-8">
          <h2 className="text-2xl font-semibold mb-6">
            Submit for Review &amp; Approval
          </h2>

          <div className="flex justify-center">
            {/* ── If already pending, show the pending info block ───────────── */}
            {statusName === "pending" ? (
              <div className="bg-white rounded-lg shadow-sm p-6 max-w-lg w-full">
                <div className="flex flex-col items-center">
                  <FaCheckCircle className="text-green-600 text-6xl mb-4" />
                  <span className="text-green-600 text-lg font-medium mb-6">
                    Successfully Submitted
                  </span>
                  <div className="flex items-start bg-yellow-100 border border-yellow-400 text-yellow-900 px-4 py-3 rounded-md">
                    <FaInfoCircle className="mt-1 mr-2" />
                    <p className="text-sm text-left">
                      Once your PDE is reviewed &amp; approved by Sub-Registrar
                      Office you will be eligible for submitting the stamp duty.
                      You can see application status in dashboard.
                    </p>
                  </div>
                </div>
              </div>
            ) : !isSubmitted ? (
              /* ── Otherwise, show the "Are you sure?" form ──────────────── */
              <div className="bg-white rounded-lg shadow-sm p-6 max-w-lg w-full">
                <p className="text-gray-800 mb-4">
                  Are you sure you want to submit this form for office review
                  and approval? Once submitted, you won’t be able to make
                  further changes.
                </p>
                <a
                  href="/Property"
                  className="text-blue-600 hover:underline flex items-center mb-6"
                >
                  I want to recheck <FaSearch className="ml-1" />
                </a>
                <label className="block text-gray-700 font-medium mb-2">
                  Select Office for Submission:
                </label>
                <select
                  className="w-full border border-gray-300 rounded-md p-2 mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={selectedOffice}
                  onChange={handleOfficeChange}
                >
                  <option value="">-- Select Office --</option>
                  {officeList.map((office) => (
                    <option key={office.sroCode} value={office.sroCode}>
                      {office.sroNameEng}
                    </option>
                  ))}
                </select>

                <button
                  onClick={() => {
                    if (!selectedOffice) {
                      alert("Please select an office before submitting!");
                      return;
                    }
                    handleSubmit(selectedOffice);
                  }}
                  className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-6 rounded-full"
                >
                  Submit PDE to Sub-Registrar Office
                </button>

                {/* <button
                  onClick={handleSubmit}
                  className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-6 rounded-full"
                >
                  Submit PDE to Sub-Registrar office
                </button> */}
              </div>
            ) : (
              /* ── Or show the post-submit success block ─────────────────— */
              <div className="bg-white rounded-lg shadow-sm p-6 max-w-lg w-full">
                <div className="flex flex-col items-center">
                  <FaCheckCircle className="text-green-600 text-6xl mb-4" />
                  <span className="text-green-600 text-lg font-medium mb-6">
                    Successfully Submitted
                  </span>
                  <div
                    className="flex items-start 
                  bg-yellow-100 border border-yellow-400 text-yellow-900 px-4 py-3 rounded-md"
                  >
                    <FaInfoCircle className="mt-1 mr-2" />
                    <p className="text-sm text-left">
                      Once your PDE is reviewed &amp; approved by Sub-Registrar
                      Office you will be eligible for submitting the stamp duty.
                      You can see application status in dashboard.
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ReviewApproval;
